const performanceOptimizationServicesData = [
  {
    title: "Audits",
    description:
      "Comprehensive audits covering Core Web Vitals, profiling, tracing, and bottleneck analysis across the stack.",
    bullets: ["Lighthouse", "Profiler", "Tracing", "Budgets"],
    minHeight: 400,
  },
  {
    title: "Frontend",
    description:
      "Optimize bundles, images, and caching with code splitting, lazy loading, and CDN strategies.",
    bullets: ["Code Split", "Images", "Caching", "CDN"],
    minHeight: 400,
  },
  {
    title: "Backend",
    description:
      "Tune databases, queries, and concurrency with indexing, query analysis, and connection pooling.",
    bullets: ["Indexes", "N+1", "Caching", "Scaling"],
    minHeight: 400,
  },
  {
    title: "Infra",
    description:
      "Improve server, network, and storage performance through right‑sizing, TLS/compression, and I/O tuning.",
    bullets: ["I/O", "Latency", "TLS", "Compression"],
    minHeight: 400,
  },
  {
    title: "Monitoring",
    description:
      "RUM/APM dashboards with actionable alerts, error budgets, and SLOs to catch regressions early.",
    bullets: ["RUM", "APM", "Alerts", "Error Rates"],
    minHeight: 400,
  },
  {
    title: "Governance",
    description:
      "Performance budgets, guardrails, and regression tests wired into CI to maintain speed over time.",
    bullets: ["Perf Budgets", "Guardrails", "Tests", "CI"],
    minHeight: 400,
  },
  {
    title: "Database Performance",
    description:
      "Schema design reviews, indexing strategy, and query plan optimization to reduce latency and cost.",
    bullets: ["Indexes", "Query Plans", "Caching", "Sharding"],
    minHeight: 400,
  },
  {
    title: "Network Optimization",
    description:
      "Optimize TLS, HTTP/2/3, and content compression with Brotli, caching directives, and edge policies.",
    bullets: ["HTTP/3", "TLS", "Brotli", "H2 Push"],
    minHeight: 400,
  },
  {
    title: "Capacity Planning",
    description:
      "Load tests and SLO‑driven capacity planning to maintain headroom, predict peaks, and autoscale safely.",
    bullets: ["Load Tests", "SLOs", "Headroom", "Autoscale"],
    minHeight: 400,
  },
];

export default performanceOptimizationServicesData;
